import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PopoverBody } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SearchIcon } from 'assets/icon-search.svg';
import { ReactComponent as LockIcon } from 'assets/icon-lock.svg';
import { TextField } from 'shared/components/form/Inputs';
import { ButtonLabelIcon } from 'shared/components/Buttons';
import { LabelIcon } from 'shared/components/Labels';
import { PopoverSort } from 'shared/components/SharedStyles/SharedStyles';
import { colors } from 'shared/defaultTheme';
import {
  setIsClientAccessManagerSelectorOpen,
  setClientAccessManagerAction,
  setClientAccessManagerSearchText,
} from 'redux/actions/clientAccessManagerActions';
import { OptionMenu } from '../styles';

const HeaderActions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [popoverOpen, setPopoverOpen] = useState(false);

  const { clientAccessManagerSearchText } = useSelector((state) => state.clientAccessManager);

  const options = [
    {
      label: t('client_access_manager_add_option'),
      action: 'add',
    },
    {
      label: t('client_access_manager_resend_option'),
      action: 'resend',
    },
    {
      label: t('client_access_manager_remove_option'),
      action: 'remove',
    },
  ];

  const onChangeSearch = (e) => {
    if (e) {
      e.preventDefault();
      const { value } = e.target;
      dispatch(setClientAccessManagerSearchText(value || ''));
    } else {
      dispatch(setClientAccessManagerSearchText(''));
    }
  };

  const handleOptionClick = (action) => {
    dispatch(setClientAccessManagerAction(action));
    dispatch(setIsClientAccessManagerSelectorOpen(true));
    setPopoverOpen(!popoverOpen);
  };

  return (
    <>
      <div className="d-flex justify-content-end action-header-mobile">
        <div className="form w-25 h-50 mr-4 w-container-search-mobile">
          <TextField
            borderRadius={2}
            className="mb-4 w-search-clients m-0 h-50"
            inputClassName="w-100"
            rightIcon={<SearchIcon fill={colors.black} />}
            value={clientAccessManagerSearchText}
            onChange={onChangeSearch}
          />
        </div>
        <div className="d-flex btn-action-clients">
          <ButtonLabelIcon
            id="PopoverSortClient"
            text={t('client_access_manager_actions_buton')}
            type="button"
            Icon={() => <LockIcon fill={colors.black} />}
            className="button-icon mr-1"
          />
        </div>
      </div>
      <PopoverSort
        placement="bottom"
        target="PopoverSortClient"
        isOpen={popoverOpen}
        toggle={() => setPopoverOpen(!popoverOpen)}
      >
        <PopoverBody>
          {options.map((option) => (
            <OptionMenu
              key={option.action}
              onClick={() => handleOptionClick(option.action)}
              aria-hidden="true"
            >
              <LabelIcon
                label={option.label}
                color=""
                className="ml-1 body-text--primary action-option-order-label font-weight-normal"
                classNameMain="my-2 label-icon-sort"
                isStyle={false}
              />
            </OptionMenu>
          ))}
        </PopoverBody>
      </PopoverSort>
    </>
  );
};

export default HeaderActions;
